import { Stack } from "@chakra-ui/react";
import FailedEmails from "@/features/failed-emails/FailedEmails";

const FailedEmailsPage = () => {
  return (
    <Stack gap={5}>
      <FailedEmails />
    </Stack>
  );
};
export default FailedEmailsPage;
